import { getSupabase } from '@/lib/supabase'
import { openWorkspaceDb } from '@/offline/db'
import type { Category } from '@/offline/types'

/**
 * Initial pull of the workspace's categories from Supabase into Dexie so the
 * purchase form has options before any local edits exist. Server-seeded starter
 * categories arrive here after provision_workspace.
 */
export async function pullCategories(workspaceId: string): Promise<number> {
  const { data, error } = await getSupabase()
    .from('categories')
    .select('*')
    .eq('workspace_id', workspaceId)
    .is('deleted_at', null)
  if (error) throw error

  const rows = (data ?? []) as Category[]
  if (rows.length === 0) return 0
  const db = openWorkspaceDb(workspaceId)
  await db.categories.bulkPut(rows)
  return rows.length
}
